import { Alert, List, Stack, Text, Title } from '@mantine/core';

export const SigningIn = () => {
    return (
        <Stack gap="md">
            <Title order={3}>Signing In</Title>

            <Alert color="yellow" title="SSO Users" mb="sm">
                If your organization uses Single Sign-On (SSO), these steps do not apply to you.
                Please see the "Single Sign-On (SSO)" topic for instructions on how to sign in.
            </Alert>

            <Text>The steps below apply to users who sign in with a username and password:</Text>

            <List type="ordered" spacing="sm">
                <List.Item>Enter your email address on the sign-in screen</List.Item>
                <List.Item>If you have used this device before, your account will appear — click on it to continue</List.Item>
                <List.Item>If this is your first time, the system will look up your account and add it to your device</List.Item>
                <List.Item>Enter your password when prompted</List.Item>
                <List.Item>You will be redirected to your application</List.Item>
            </List>

        </Stack>
    );
};
